var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 0.625V1.875H12.2266L4.55078 9.55078L5.44922 10.4492L13.125 2.77344V6.25H14.375V0.625H8.75ZM0.625 3.125V14.375H11.875V6.25L10.625 7.5V13.125H1.875V4.375H7.5L8.75 3.125H0.625Z",
    color: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoExternalLink);
export default __webpack_public_path__ + "static/media/ico-external-link.5393c8c6511ee3aca09cf32196091c97.svg";
export { ForwardRef as ReactComponent };